import { useApiPut } from '@sierralabs/core-ui';
export function useUpdateSite(id) {
    const { data, isLoading, error, put } = useApiPut(`sites/${id}`);
    return {
        updatedSite: data,
        updating: isLoading,
        updateError: error,
        updateSite: put
    };
}
//# sourceMappingURL=useUpdateSite.js.map